import { Box, Button } from '@mui/material';
import { FeedbackType, PostCallFeedbackState } from './types';
import { useTracking } from '../../../tracking';

interface FeedbackActions {
  feedbackType: FeedbackType;
  onClose: () => void;
  submitFeedback: (feedback?: PostCallFeedbackState) => Promise<void>;
  isUpdatingPostCallFeedback: boolean;
  postCallFeedback: PostCallFeedbackState;
}

const FeedbackActions = ({
  feedbackType,
  onClose,
  submitFeedback,
  isUpdatingPostCallFeedback,
  postCallFeedback,
}: FeedbackActions) => {
  const tracking = useTracking();
  const { generateTrackingProps } = tracking || {};

  return (
    <Box
      sx={{
        alignSelf: 'flex-end',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '16px',
      }}
    >
      <Button
        variant="outlined"
        {...(generateTrackingProps
          ? generateTrackingProps('close-button')
          : {})}
        onClick={onClose}
      >
        Close
      </Button>
      <Button
        variant="contained"
        {...(generateTrackingProps
          ? generateTrackingProps('submit-button')
          : {})}
        onClick={async () => await submitFeedback()}
        disabled={
          isUpdatingPostCallFeedback ||
          (feedbackType === 'summary' &&
            postCallFeedback.isAccurateSummary === null) ||
          (feedbackType === 'transcription' &&
            postCallFeedback.isAccurateTranscription === null) ||
          (feedbackType === 'suggestions' &&
            postCallFeedback.isAccurateSuggestion === null)
        }
      >
        Submit
      </Button>
    </Box>
  );
};

export default FeedbackActions;
